import { FormattedMessage } from 'react-intl';

import { Content } from '#src/components/fiatWallet/CreateFiatWallet/Onboarding/Content/index.tsx';
import type { CreateFiatWalletSteps } from '#src/components/fiatWallet/CreateFiatWallet/type.ts';
import { useCurrentUserCurrencies } from '#src/hooks/useCurrentUserCurrencies.tsx';

type Props = {
  setStep: (tab: CreateFiatWalletSteps) => void;
  onDismiss?: () => void;
};
export const ActivateYourCashWallet = (props: Props) => {
  const { cryptocurrencySymbol } = useCurrentUserCurrencies();
  const news = [
    {
      id: 'expand',
      title: <FormattedMessage defaultMessage="Expand your reach" />,
      desc: (
        <FormattedMessage defaultMessage="Get access to tens of thousands of Managers using Cash to buy cards in Manager Sales." />
      ),
    },
    {
      id: 'deposit',
      title: <FormattedMessage defaultMessage="Control your listings" />,
      desc: (
        <FormattedMessage
          defaultMessage="Choose the currency your listings will be based on (Cash or {cryptocurrencySymbol}). You can always choose to list exclusively in {cryptocurrencySymbol}."
          values={{
            cryptocurrencySymbol,
          }}
        />
      ),
    },
  ];
  return (
    <Content
      {...props}
      news={news}
      title={<FormattedMessage defaultMessage="Activate your Cash Wallet" />}
    />
  );
};
